import {serviceRequestOrm} from '@/utils/orm-tools/serviceRequest'
import {getNextPublicId} from '@/utils/product/helpers'

import {Jurisdiction} from '../countries/constants'
import {InvoiceFragment, Order_By, ServiceRequestFragment} from '../graphqlSdk'
import {postFilingLegalServices} from './constants'
import {LegalServices, ServiceRequestInternalType, ServiceRequestStatus} from './types'

export const filterLegalServicesForResponseToOpposition = () => {
  const serviceKeysForResponseToOpposition = [
    LegalServices.gsLimitation,
    LegalServices.coexistenceAgreement,
    LegalServices.responseToObjection,
  ]

  return postFilingLegalServices.filter(({key}) =>
    serviceKeysForResponseToOpposition.includes(key as LegalServices),
  )
}

export const isServiceRequestOrderCompleted = (
  request: ServiceRequestFragment | null,
  invoice?: InvoiceFragment | null,
) =>
  Boolean(
    request?.tracking_actions?.find(
      (action) => action.name === ServiceRequestStatus.orderCompleted,
    ) && !!invoice?.revolut_public_order_id,
  )

export const getServiceRequestNextPublicId = async () => {
  const [lastRequest] = await serviceRequestOrm.getMany(
    {},
    {public_id: Order_By.DescNullsLast},
    0,
    1,
  )

  const lastPublicId = lastRequest?.public_id ?? '0'

  return getNextPublicId('LS', lastPublicId)
}

export const getIpCaseType = (jurisdiction: Jurisdiction) => {
  switch (jurisdiction) {
    case Jurisdiction.US:
      return ServiceRequestInternalType.USIPCase
    case Jurisdiction.EU:
      return ServiceRequestInternalType.EUIPCase
    case Jurisdiction.UK:
      return ServiceRequestInternalType.UKIPCase
    case Jurisdiction.SK:
    case Jurisdiction.CZ:
      return ServiceRequestInternalType.SKCZIPCase
    default:
      return ServiceRequestInternalType.otherIPCase
  }
}
